import { render, staticRenderFns } from "./MidiaVerticalTextView.vue?vue&type=template&id=34f612f4&scoped=true"
import script from "./MidiaVerticalTextView.vue?vue&type=script&lang=js"
export * from "./MidiaVerticalTextView.vue?vue&type=script&lang=js"
import style0 from "./MidiaVerticalTextView.vue?vue&type=style&index=0&id=34f612f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f612f4",
  null
  
)

export default component.exports